/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   isBedroomsSelected
 */

import type { Filters } from '@zcode/state-type'

/**
 * true if any bedrooms is selected
 *
 * @param filters
 */
export function isBedroomsSelected<F extends Partial<Filters> | null | undefined>(
  filters: F
): filters is NonNullable<F> & Pick<Filters, 'bedrooms'> {
  return !!filters && !!filters.bedrooms && filters.bedrooms.some((category: boolean) => category)
}
